// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import {
  getEventoInfo,
  configTypeTickets,
} from "@/features/evento/eventoThunks";
import { getEmpresaInfo } from "@/features/empresa/empresaThunks";
import { parseUTCDate } from "@/utils/dateHelpers";

// React Utils
import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Componentes
import Breadcrum from "@/components/Breadcrum";
import CardEvento from "@/components/CrearDetailEvento/CardEvento";
import CardAmbassadors from "@/components/CrearDetailEvento/CardAmbassadors";
import CardTickets from "@/components/CrearDetailEvento/CardTickets";
import FixedAddToCart from "@/components/CrearDetailEvento/FixedAddToCart";
import { useToast, ToastContainer } from "@/components/ui/Toast";
import Modal from "@/components/Modals/Modal";
import PublicarEvento from "@/components/Forms/PublicarEvento";

// Componentes segunda sección
import CardAseguraTuTicket from "@/components/CrearDetailEvento/CardAseguraTuTicket";
import CardProximasFechas from "@/components/CrearDetailEvento/CardProximasFechas";

// Assets
import EventImage1 from "@/assets/eventos/ViejasDeMierda.webp";
import Ambassador5 from "@/assets/recentAmbassador/mujer5.webp";
import Ambassador6 from "@/assets/recentAmbassador/duo.webp";
import Ambassador7 from "@/assets/recentAmbassador/chris.webp";
import LogoPerfilEmpresa from "@/assets/avatars/avatar_amanda.webp";
import LogoAppWhoop from "@/assets/Logo-AppWhoop.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Simulacion de props para el componente
// Lista de próximas fechas (eventos)

export default function CrearEvento() {
  // Obtener la ubicación actual
  const location = useLocation();
  const navigate = useNavigate();
  // Obtener el ID del evento de los parámetros de la ruta
  const { id, idEvento } = useParams();
  console.log("ID del evento desde la URL:", id, idEvento);

  // Estados locales para el manejo de la carga
  const [isLoading, setIsLoading] = useState(true);
  const [dataLoadComplete, setDataLoadComplete] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);

  // Estados para modales de publicación
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState({
    title: "",
    message: "",
    showLink: false,
  });

  // Toast notifications
  const { toasts, removeToast, success, error, info, warning } = useToast();

  // Redux state
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const {
    infoEvento,
    isLoading: eventoLoading,
    error: eventoError,
  } = useSelector((state) => state.evento);
  const { infoEmpresa } = useSelector((state) => state.empresa);

  useEffect(() => {
    // Obtener información del evento y empresa desde el estado de Redux
    const loadData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(getEventoInfo({ uidEvento: idEvento })),
          dispatch(getEmpresaInfo({ uid: id })),
        ]);

        // Marcar que los datos se han cargado exitosamente
        setDataLoadComplete(true);
      } catch (error) {
        console.error("Error loading event data:", error);
        // En caso de error, también completamos la carga para mostrar el contenido
        setDataLoadComplete(true);
      }
    };

    loadData();
  }, [dispatch, id, idEvento, location.pathname]);

  // Verificar si todas las cargas de Redux han terminado
  useEffect(() => {
    if (dataLoadComplete && !eventoLoading) {
      // Pequeño delay para asegurar que la pantalla de carga se vea
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [dataLoadComplete, eventoLoading]);

  // Función que se ejecuta cuando la animación de carga termina
  const handleLoadComplete = () => {
    setIsLoading(false);
  };

  // Si hay errores críticos, mostrar la pantalla de carga por un tiempo mínimo
  useEffect(() => {
    if (eventoError) {
      const errorTimer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(errorTimer);
    }
  }, [eventoError]);

  // Verificar acceso del usuario al evento
  useEffect(() => {
    if (dataLoadComplete && !eventoLoading && infoEvento) {
      // Verificar si el usuario tiene acceso (myself debe estar presente y ser true)
      if (!infoEvento.myself) {
        setAccessDenied(true);
      } else {
        setAccessDenied(false);
      }
    }
  }, [dataLoadComplete, eventoLoading, infoEvento]);

  const isLoadingVerify = isLoading || eventoLoading || !dataLoadComplete;
  // Datos simulados del evento
  const evento = {
    id,
    titulo: "VIEJAS DE MIERDA 'Única Función'",
    fecha: "Domingo 4 de Agosto - 19:00 hrs",
    subtitulo: "Ticket con Descuento",
    img: LogoAppWhoop, // Cambia por tu ruta real
    enDescuento: true,
    descripcion:
      "La obra de Gloria Münchmayer, Gabriela Hernández y Gloria Benavides llega al teatro CA 660 lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. \n Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    ubicacion: "Rosario Norte 660. Las Condes",
    palabrasClave: ["Obra de Teatro", "Humor", "Las Condes", "Metro Manquehue"],
    // embajadores: [
    //   {
    //     nombre: "Christopher Ferrada",
    //     rol: "Líder de Staff",
    //     img: Ambassador7,
    //   },
    //   { nombre: "Ana Pérez", rol: "Embajadora", img: Ambassador5 },
    //   { nombre: "Luis Soto", rol: "Embajador", img: Ambassador6 },
    // ],
    tickets: [
      { tipo: "Invitacion", precio: 0, label: "$GRATIS", disponible: true },
      { tipo: "General", precio: 20000, label: "$20.000", disponible: true },
      { tipo: "Mesa Vip", precio: 250000, label: "$250.000", disponible: true },
      {
        tipo: "Mesa Golden",
        precio: 300000,
        label: "$300.000",
        disponible: true,
      },
    ],
  };

  // Lista de próximos eventos
  const proximosEventos = [
    {
      img: EventImage1,
      titulo: "Alpine Escape",
      fecha: "31/10/2025",
      rating: 4,
      ratingText: "4/5",
    },
    {
      img: EventImage1,
      titulo: "Caribbean Cruise",
      fecha: "31/10/2025",
      rating: 5,
      ratingText: "5/5",
    },
    {
      img: EventImage1,
      titulo: "Parisian Romance",
      fecha: "31/10/2025",
      rating: 4.5,
      ratingText: "4.5/5",
    },
    {
      img: EventImage1,
      titulo: "Greek Island Hopping",
      fecha: "31/10/2025",
      rating: 4.5,
      ratingText: "4.5/5",
    },
  ];

  // Lista de beneficios
  const benefitsList = [
    {
      icon: "certificate",
      title: "Empresa Verificada",
      description:
        "Enjoy gourmet meals, drinks, and activities included in your package",
    },
    {
      icon: "fan",
      title: "Ticket de Cortesía",
      description:
        "Contamos con invitaciones de cortesía. Te debes validar desde el link",
    },
    {
      icon: "water",
      title: "Water Sports",
      description: "Access to snorkeling, diving, and other water sports",
    },
    {
      icon: "person-rays",
      title: "Luxury Accommodation",
      description:
        "Stay in a private overwater villa with breathtaking ocean views",
    },
    {
      icon: "seedling",
      title: "Sustainability",
      description:
        "Eco-friendly resort with a commitment to preserving marine life and supporting local communities.",
    },
  ];

  const breadcrumLinks = [
    {
      label: (
        <>
          <FontAwesomeIcon icon="fa-solid fa-arrow-circle-left" />
          <span className="ml-1">Volver</span>
        </>
      ),
      href: `/empresa/${id}`,
    },
    {
      label: `${isLoadingVerify ? "Cargando..." : infoEvento.nombre}`,
      href: "#",
    },
  ];

  const pendingAmbassadorsSample = [
    { id: 1, name: "Ana Pérez", img: Ambassador5, ticketsVendidos: 15 },
    { id: 2, name: "Luis Soto", img: Ambassador6, ticketsVendidos: 10 },
  ];
  const allAmbassadorsSample = [
    { id: 1, name: "Ana Pérez", img: Ambassador5, ticketsVendidos: 15 },
    { id: 2, name: "Luis Soto", img: Ambassador6, ticketsVendidos: 10 },
    {
      id: 3,
      name: "Christopher Ferrada",
      img: Ambassador7,
      ticketsVendidos: 5,
    },
    { id: 4, name: "María González", img: Ambassador5, ticketsVendidos: 8 },
    { id: 5, name: "Pedro Martínez", img: Ambassador6, ticketsVendidos: 12 },
    { id: 6, name: "Lucía Fernández", img: Ambassador7, ticketsVendidos: 7 },
    { id: 7, name: "Javier Rodríguez", img: Ambassador5, ticketsVendidos: 9 },
    { id: 8, name: "Sofía López", img: Ambassador6, ticketsVendidos: 11 },
    { id: 9, name: "Diego Sánchez", img: Ambassador7, ticketsVendidos: 6 },
    {
      id: 10,
      name: "Valentina Ramírez",
      img: Ambassador5,
      ticketsVendidos: 14,
    },
  ];
  const initialSelectedAmbassadorsSample = []; // IDs de embajadores inicialmente seleccionados

  // Función para manejar el submit de tickets
  const handleTicketsSubmit = async (tickets) => {
    // Mostrar toast de carga
    info("Guardando configuración de tickets...", {
      autoClose: true,
      duration: 2000,
    });

    try {
      // Mapear los datos del frontend al formato esperado por el backend
      const ticketsData = tickets.map((ticket, index) => {
        console.log(`Procesando ticket ${index}:`, {
          id: ticket.id,
          customTypeName: ticket.customTypeName,
          hasCustomImage: ticket.customImage instanceof File,
          fileName: ticket.customImage?.name,
          useEventImage: ticket.useEventImage,
        });

        const mappedTicket = {
          customTypeName:
            ticket.customTypeName || ticket.title || `Ticket ${index + 1}`,
          precio: ticket.price || 0,
          precioSinIva: ticket.precioSinIva || 0,
          utilidadNeta: ticket.utilidadNeta || 0,
          utilidadNetaConIva: ticket.utilidadNetaConIva || 0,
          comisionAW: ticket.comisionAW || 0,
          comisionAWConIva: ticket.comisionAWConIva || 0,
          comisionAmbassador: ticket.comisionAmbassador || 0,
          comisionAmbassadorConIva: ticket.comisionAmbassadorConIva || 0,
          cantidadEnVenta: ticket.quantity || 1,
          limitePorPersona: ticket.maxPerUser || 1,
          ticketGrupal: ticket.ticketGrupal || false, // Usar directamente el campo del estado
          cantidadPersonasTicketGrupal: ticket.ticketGrupal
            ? ticket.groupSize || 2
            : null,
          useImgEvento:
            ticket.useEventImage !== undefined ? ticket.useEventImage : true,
          customImage: ticket.customImage || null,
          positionOrder: index + 1,
          // Campos de invitacion
          esInvitacion: ticket.esInvitacion || false,
          invitacionCupoGratuito: ticket.invitacionCupoGratuito ?? null,
          invitacionHoraLimiteGratuita: ticket.invitacionHoraLimiteGratuita ?? null,
          invitacionDescuento: ticket.invitacionDescuento ?? null,
          invitacionHoraLimiteDescuento: ticket.invitacionHoraLimiteDescuento ?? null,
        };

        // Si el ticket tiene un ID numérico (ticket existente), incluirlo
        if (ticket.id && typeof ticket.id === "number") {
          mappedTicket.id = ticket.id;
        }

        console.log(`Ticket ${index} mapeado:`, {
          ...mappedTicket,
          hasCustomImageFile: mappedTicket.customImage instanceof File,
          customImageName: mappedTicket.customImage?.name,
        });

        return mappedTicket;
      });

      console.log("Datos a enviar al backend:", ticketsData);

      // Dispatch del thunk
      const result = await dispatch(
        configTypeTickets({
          uidEvento: idEvento,
          ticketsData,
        }),
      );

      if (configTypeTickets.fulfilled.match(result)) {
        // Limpiar toasts anteriores y mostrar éxito
        success(
          `✅ Configuración de tickets guardada exitosamente. Se ${
            ticketsData.length === 1
              ? "configuró 1 tipo de ticket"
              : `configuraron ${ticketsData.length} tipos de tickets`
          }.`,
          { duration: 5000 },
        );

        // Los datos actualizados ya están en Redux gracias al dispatch en eventoThunks
        console.log(
          "Tickets guardados exitosamente, Redux actualizado automáticamente",
        );
      } else {
        throw new Error(result.payload || "Error al guardar tipos de tickets");
      }
    } catch (err) {
      console.error("Error al guardar tipos de tickets:", err);

      // Mostrar error específico
      const errorMessage = err.message.includes("Network")
        ? "🌐 Error de conexión. Verifica tu internet e intenta nuevamente."
        : err.message.includes("validation")
          ? "⚠️ Error de validación. Revisa que todos los campos estén correctamente llenos."
          : `❌ Error al guardar: ${err.message}`;

      error(errorMessage, { duration: 7000 });
    }
  };

  // Función para verificar si se puede publicar el evento
  const handlePublishAttempt = () => {
    const empresaPublished = infoEmpresa?.published;

    if (empresaPublished === 1) {
      // Empresa activada, permitir publicar
      setShowPublishModal(true);
    } else if (empresaPublished === 0) {
      // Empresa no ha enviado documentos
      setWarningMessage({
        title: "Empresa no activada",
        message:
          "Para poder publicar eventos, primero debes activar tu empresa enviando los documentos requeridos.",
        showLink: true,
      });
      setShowWarningModal(true);
    } else if (empresaPublished === 2) {
      // Empresa en revisión
      setWarningMessage({
        title: "Empresa en revisión",
        message:
          "Tus documentos están siendo revisados. Este proceso puede tomar hasta 2 días hábiles. Si ya han pasado más de 2 días, puedes contactarnos a support@appwhoop.com para consultar el estado.",
        showLink: false,
      });
      setShowWarningModal(true);
    } else {
      // Estado desconocido
      setWarningMessage({
        title: "Estado desconocido",
        message:
          "No se puede determinar el estado de tu empresa. Por favor, contacta a soporte.",
        showLink: false,
      });
      setShowWarningModal(true);
    }
  };

  // Preparar datos iniciales de tickets desde Redux si existen
  const initialDataTickets =
    infoEvento?.tiposTicket?.map((ticket, index) => {
      console.log(`Inicializando ticket ${index}:`, {
        id: ticket.id,
        useImgEvento: ticket.useImgEvento,
        imgTicket: ticket.imgTicket,
        customTypeName: ticket.customTypeName,
      });

      return {
        id: ticket.id, // Mantener el ID real de la base de datos
        type: "custom",
        customTypeName: ticket.customTypeName || "",
        title: ticket.customTypeName || "Ticket",
        price: ticket.precio || 0,
        precioSinIva: ticket.precioSinIva || 0,
        utilidadNeta: ticket.utilidadNeta || 0,
        utilidadNetaConIva: ticket.utilidadNetaConIva || 0,
        comisionAW: ticket.comisionAW || 0,
        comisionAWConIva: ticket.comisionAWConIva || 0,
        comisionAmbassador: ticket.comisionAmbassador || 0,
        comisionAmbassadorConIva: ticket.comisionAmbassadorConIva || 0,
        quantity: ticket.cantidadEnVenta || 1,
        scope: ticket.ticketGrupal ? "group" : "individual",
        groupSize: ticket.cantidadPersonasTicketGrupal || 1,
        maxPerUser: ticket.limitePorPersona || 1,
        useEventImage:
          ticket.useImgEvento !== undefined ? ticket.useImgEvento : true,
        customImage: null, // Siempre null inicialmente, las URLs van en customImagePreview
        customImagePreview: ticket.imgTicket || null, // URL de la imagen existente para preview
        ticketGrupal: ticket.ticketGrupal || false, // Incluir el campo de la base de datos
        esInvitacion: ticket.esInvitacion,
        invitacionCupoGratuito: ticket.invitacionCupoGratuito ?? null,
        invitacionHoraLimiteGratuita: ticket.invitacionHoraLimiteGratuita,
        invitacionDescuento: ticket.invitacionDescuento ?? null,
        invitacionHoraLimiteDescuento: ticket.invitacionHoraLimiteDescuento
          ? ticket.invitacionHoraLimiteDescuento ?? null
          : null,
      };
    }) || [];

  console.log("infoEvento desde Redux:", infoEvento);
  console.log("1 - initialDataTickets:", initialDataTickets);
  // Layout principal
  // console.log("publicado o no:", infoEvento?.published);

  // Si el acceso es denegado, mostrar mensaje de acceso denegado
  if (!isLoadingVerify && accessDenied) {
    return (
      <>
        <ToastContainer toasts={toasts} onRemove={removeToast} />
        <div className="relative min-h-screen bg-aw-bluedark-95 sm:bg-transparent w-full flex flex-col items-center justify-center px-4 pb-6 pt-2">
          <div className="max-w-2xl w-full bg-aw-bgbluedark rounded-lg shadow-2xl p-8 text-center">
            <FontAwesomeIcon
              icon="fa-solid fa-lock"
              className="text-red-500 mb-6"
              size="4x"
            />
            <h1 className="text-3xl font-bold text-white mb-4">
              Acceso Denegado
            </h1>
            <p className="text-gray-300 mb-6 text-lg">
              No tienes permisos para acceder a esta vista del evento.
            </p>
            <p className="text-gray-400 mb-8">
              Solo el propietario del evento puede acceder a esta página de
              configuración. Si crees que esto es un error, contacta al soporte
              técnico.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate(`/empresa/${id}`)}
                className="px-6 py-3 bg-aw-green text-aw-bluedark rounded-lg font-semibold hover:scale-95 transition-all"
              >
                <FontAwesomeIcon
                  icon="fa-solid fa-arrow-left"
                  className="mr-2"
                />
                Volver a la empresa
              </button>
              <button
                onClick={() => navigate("/")}
                className="px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold hover:scale-95 transition-all"
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Toast Container */}
      <ToastContainer toasts={toasts} onRemove={removeToast} />

      {/* Barra de CTA para agregar los tickets seleccionados */}
      {isLoadingVerify ? (
        <SkeletonTheme
          baseColor="#0f172a"
          highlightColor="#1e293b"
          className="sm:hidden top-0"
        >
          <div className="w-full sticky bottom-0 z-[80]">
            <Skeleton height={70} className="w-full" />
          </div>
        </SkeletonTheme>
      ) : (
        <FixedAddToCart evento={infoEvento} responsive={"sm:hidden top-0"} />
      )}
      <div className="relative min-h-screen bg-aw-bluedark-95 sm:bg-transparent w-full flex flex-col px-4 pb-6 pt-2">
        {/* Navegación */}
        <div className="flex justify-between items-center">
          <Breadcrum links={breadcrumLinks} />
          {infoEvento?.published === 0 && (
            <button
              onClick={handlePublishAttempt}
              className="bg-aw-green px-4 py-2 rounded-full flex items-center hover:scale-95 transition duration-300"
            >
              <FontAwesomeIcon
                icon="fa-solid fa-cloud-arrow-up"
                className="text-aw-bluedark hover:text-aw-bluedark/80 mr-2 transition duration-300"
              />
              Publicar Evento
            </button>
          )}
        </div>
        {/* Sección superior: Card del evento, Card de embajadores y Card de tickets */}

        {isLoadingVerify ? (
          <SkeletonTheme baseColor="#0f172a" highlightColor="#1e293b">
            <div className="flex flex-row justify-between gap-x-4 items-center mb-6">
              <div className="w-1/3">
                <Skeleton height={500} borderRadius={8} />
              </div>
              <div className="w-1/3">
                <Skeleton height={500} borderRadius={8} />
              </div>
              <div className="w-1/3">
                <Skeleton height={500} borderRadius={8} />
              </div>
            </div>
          </SkeletonTheme>
        ) : (
          <div className="flex flex-col lg:flex-row gap-y-5 sm:gap-10 mt-2">
            {/* Card que muestra el evento */}
            <div className="flex-1 w-full flex flex-col items-center lg:items-start">
              <CardEvento initialData={infoEvento} />
            </div>

            {/* Card que muestra en móviles las funciones de agregar o disminuir cantidad de tickets y postular a ticket gratuito */}
            {/* <div className="sm:hidden flex-1 w-full flex flex-col items-center lg:items-end">
              <CardTickets
                initialTickets={initialDataTickets}
                onSubmit={handleTicketsSubmit}
                eventImage={infoEvento?.imgEvento || evento.img}
              />
            </div> */}
            <div className="flex-1 w-full flex flex-col items-center">
              {/* TODO: Retomar en la versión 1.5 */}
              {/* Card central donde se muestra el staff y la inforamción relevante del evento */}
              <CardAmbassadors
                pendingAmbassadors={pendingAmbassadorsSample}
                allAmbassadors={allAmbassadorsSample}
                initialSelectedAmbassadors={initialSelectedAmbassadorsSample}
                infoEvento={infoEvento}
                infoEmpresa={infoEmpresa}
                onSave={() => {
                  (data) => console.log("Guardado", data);
                }}
              />
            </div>
            {/* Card que muestra en noMóviles las funciones de agregar o disminuir cantidad de tickets y postular a ticket gratuito */}
            <div className="flex-1 w-full sm:flex flex-col items-center lg:items-end">
              <CardTickets
                initialTickets={initialDataTickets}
                onSubmit={handleTicketsSubmit}
                eventImage={infoEvento?.imgEvento || evento.img}
                showToast={{ success, error, info, warning }}
                eventAforo={infoEvento?.aforo || 0}
                eventInfo={infoEvento || {}}
                infoEmpresa={infoEmpresa}
              />
            </div>
          </div>
        )}

        <hr className="my-6 border-aw-green/25" />

        {/* Sección inferior: Asegura tu Ticket con tiempo y Próximas Fechas */}
        {/* <div className="w-full flex flex-col lg:flex-row gap-4">
          Asegura tu ticket
          <CardAseguraTuTicket
            LogoPerfilEmpresa={LogoPerfilEmpresa}
            benefitsList={benefitsList}
          />
          Próximas Fechas
          <CardProximasFechas proximosEventos={proximosEventos} />
        </div> */}
        {/* Barra de CTA para agregar los tickets seleccionados */}

        {isLoadingVerify ? (
          <SkeletonTheme
            baseColor="#0f172a"
            highlightColor="#1e293b"
            className="hidden sm:block bottom-0"
          >
            <div className="w-full sticky bottom-0 z-[80]">
              <Skeleton height={70} className="w-full" />
            </div>
          </SkeletonTheme>
        ) : (
          <FixedAddToCart
            evento={infoEvento}
            responsive={"hidden sm:block bottom-0"}
          />
        )}
      </div>

      {/* Modal para publicar evento */}
      {showPublishModal && (
        <Modal
          isOpen={showPublishModal}
          onClose={() => {
            setShowPublishModal(false);
          }}
          large="max-w-4xl"
        >
          <PublicarEvento
            onClose={() => {
              setShowPublishModal(false);
            }}
            eventoUid={idEvento}
            idEmpresa={id}
          />
        </Modal>
      )}

      {/* Modal de advertencia para empresas no activadas */}
      {showWarningModal && (
        <Modal
          isOpen={showWarningModal}
          onClose={() => setShowWarningModal(false)}
          large="max-w-lg"
        >
          <div className="p-6 text-center bg-aw-bgbluedark rounded-lg">
            <FontAwesomeIcon
              icon="fa-solid fa-exclamation-triangle"
              className="text-yellow-500 mb-4"
              size="3x"
            />
            <h3 className="text-lg text-white font-semibold mb-4">
              {warningMessage.title}
            </h3>
            <p className="mt-2 text-gray-200 mb-6">{warningMessage.message}</p>

            <div className="flex flex-col gap-3">
              {warningMessage.showLink && (
                <button
                  onClick={() => {
                    setShowWarningModal(false);
                    navigate(`/empresa/${id}/activar`);
                  }}
                  className="px-6 py-3 bg-aw-green text-aw-bluedark rounded-lg font-semibold hover:scale-95 transition-all"
                >
                  Ir a activar empresa
                </button>
              )}

              <button
                onClick={() => setShowWarningModal(false)}
                className={`px-6 py-3 ${
                  warningMessage.showLink
                    ? "bg-gray-600 text-white"
                    : "bg-aw-green text-aw-bluedark"
                } rounded-lg font-semibold hover:scale-95 transition-all`}
              >
                {warningMessage.showLink ? "Cerrar" : "Entendido"}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
